/**
 * @generated SignedSource<<74070015af3e783c979ad30135bafaa6>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpRespSimilarItem_item$data = {
  readonly serviceId: string | null;
  readonly isFurniture: boolean | null;
  readonly " $fragmentSpreads": FragmentRefs<"ItemTile_item" | "FavoritesItem_item" | "FavoritesItemProvider_item">;
  readonly " $fragmentType": "PdpRespSimilarItem_item";
};
export type PdpRespSimilarItem_item$key = {
  readonly " $data"?: PdpRespSimilarItem_item$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespSimilarItem_item">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "isTrade"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespSimilarItem_item",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "serviceId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isFurniture",
      "storageKey": null
    },
    {
      "args": [
        {
          "kind": "Variable",
          "name": "isTrade",
          "variableName": "isTrade"
        }
      ],
      "kind": "FragmentSpread",
      "name": "ItemTile_item"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "FavoritesItem_item"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "FavoritesItemProvider_item"
    }
  ],
  "type": "Item",
  "abstractKey": null
};

(node as any).hash = "6f8b70cbb1147572269e1c23a88c21b8";

export default node;
